/**
 * A query string with an address still readable in it.
 *
 * `URLSearchParams` percent-encodes `@` as `%40` and `+` as `%2B` even though
 * neither needs escaping in a query component (RFC 3986 allows both
 * unescaped there, alongside `:`) — every browser address bar would
 * otherwise show the sign-up flow's own `?email=` with a `qa+anna` address
 * spelled `qa%2Banna`. `readQueryEmail` is `readableQuery`'s other half: it
 * has to read a raw `+` back as itself rather than as the space that
 * `URLSearchParams` would decode it to, or the two would disagree about what
 * the address in the bar actually says.
 */
export function readableQuery(params: URLSearchParams): string {
  return params.toString().replace(/%40/g, '@').replace(/%2B/g, '+');
}

/**
 * Reads one query param the way `readableQuery` wrote it — a raw `+` stays
 * `+`, not the space `URLSearchParams.get` would turn it into. Only safe for
 * params this module put there itself; anything from a plain HTML form still
 * means `+` as space.
 */
export function readQueryEmail(search: string): string | null {
  const match = new RegExp(`[?&]email=([^&]*)`).exec(search);
  return match ? decodeURIComponent(match[1]) : null;
}
